// extracted by mini-css-extract-plugin
export default {"bright":"ImagesPos_bright__LcQid","imgsize":"ImagesPos_imgsize__6Go5Q","steam":"ImagesPos_steam__X3gkS"};